export default __webpack_public_path__ + "static/bg-hero-ball-b4562990cdc86728621812a1bc518c03.png";